const locale = {
  ui: {
    titleEyebrow: 'Un juego de cartas',
    titleSub:
      'Tus primeros 90 días como Product Manager en una SaaS de tamaño medio. ' +
      'Sobrevive a 60 cartas. No te dispares ni te quedes a cero.',
    titleCta: 'Empezar el día uno',
    titleBest: 'Mejor partida',
    titleEndings: 'Finales desbloqueados',
    titleDays: 'días',
    creditsBy: 'thenew.pm — un juego de toma de decisiones web por',
    creditsTagline: 'un juego donde eres el nuevo product manager',
    playHint: 'Desliza, toca o usa ← / →',
    dayLabel: 'Día',
    endingDayLost: 'Día {day} — fin de la partida',
    endingDayWon: 'Día 90 — sobreviviste',
    endingRestart: 'Nuevo PM, nuevo comienzo',
    endingUnlocked: '{n} de {total} finales desbloqueados',
  },
  stats: {
    e: { short: 'Ing.',    label: 'Confianza ingeniería' },
    x: { short: 'Exec',    label: 'Confianza ejecutiva' },
    u: { short: 'Impacto', label: 'Impacto usuario' },
    p: { short: 'Energía', label: 'Energía personal' },
  },
  roles: {
    engineer:  'Ingeniería',
    designer:  'Diseño',
    exec:      'Ejecutivo',
    customer:  'Cliente',
    sales:     'Ventas',
    data:      'Datos',
    intern:    'Becario',
    recruiter: 'Reclutamiento',
  },
  endings: {
    e0:   { title: 'Ignorado en silencio',
            line: 'Ingeniería dejó de leer tus mensajes de Slack el día 47.' },
    e100: { title: 'Capturado por ingeniería',
            line: 'Eres PM de nombre. Los tech leads deciden ahora qué se entrega.' },
    x0:   { title: 'Despedido',
            line: 'El CEO necesitaba un chivo expiatorio para el trimestre fallido. Eras el más nuevo.' },
    x100: { title: 'Marioneta del exec',
            line: 'Entregas la slide OKR cada viernes. Nada más se ha entregado en semanas.' },
    u0:   { title: 'Fue un fracaso',
            line: 'El lanzamiento salió. Nadie notó que se entregó.' },
    u100: { title: 'Espiral de scope',
            line: 'Todas las features del muro se construyeron. Ninguna se usó.' },
    p0:   { title: 'Burnout',
            line: 'Baja médica el día 73. Tu portátil sigue en el escritorio.' },
    p100: { title: 'Espiral maníaco',
            line: 'Doc de estrategia de 47 páginas. Martes a las 3 a.m. Nadie lo pidió.' },
    w_cpo:       { title: 'CPO a regañadientes',
                   line: 'El consejo te quiere en la oficina del rincón. No estás seguro de quererlo.' },
    w_shipped:   { title: 'El PM que entregó',
                   line: 'Entregaste la cosa. La gente la usa. El equipo sigue ahí.' },
    w_hero:      { title: 'Héroe interno, misterio externo',
                   line: 'Ingeniería te adora. Marketing nunca ha oído hablar de ti.' },
    w_whisperer: { title: 'Susurrador de roadmap',
                   line: 'Nada era perfecto. Nada estaba en llamas. El equipo confía en ti.' },
    w_survivor:  { title: 'Sobreviviste 90 días',
                   line: 'Sigues aquí. Eso es la mayor parte.' },
  },
  cards: {
    c001: { title: 'Ingeniera Staff',
            prompt: 'La migración de auth se va a retrasar dos semanas. ¿Lo decimos al equipo exec ahora o esperamos a la demo del viernes?',
            left: 'Esperar la demo', right: 'Avisar hoy' },
    c002: { title: 'Diseñadora Senior',
            prompt: 'Ingeniería entregó el nuevo dashboard sin mi empty state rediseñado. Otra vez.',
            left: 'Empujar un hotfix', right: 'Meterlo en v2' },
    c003: { title: 'VP Producto',
            prompt: 'El consejo quiere una slide de "estrategia IA" para el jueves. No tenemos estrategia IA.',
            left: 'Esbozarla este finde', right: 'Decirle que es prematuro' },
    c004: { title: 'PM en TrialCo',
            prompt: '"Tu onboarding me hizo llorar. No de buena manera. Hicimos churn a vuestro competidor."',
            left: 'Programar una llamada', right: 'Reenviar a soporte' },
    c005: { title: 'AE Enterprise',
            prompt: 'Un prospect estratégico quiere SSO + audit logs + SLA custom. 500k€ ARR en juego.',
            left: 'Declinar amablemente', right: 'Construirlo' },
    c006: { title: 'Data Scientist',
            prompt: 'El A/B test no es concluyente pero ya pasamos la deadline. ¿Entregar la variante o matarla?',
            left: 'Entregar la variante', right: 'Matarla, repetir' },
    c007: { title: 'Becario de Producto',
            prompt: '"Tengo una idea para una feature. Es básicamente Slack pero para gatos."',
            left: 'Decirle que se centre', right: 'Escucharlo' },
    c008: { title: 'Reclutadora Tech',
            prompt: 'El candidato PM senior acaba de recibir una contraoferta de Stripe. Tenemos 24 horas.',
            left: 'Igualar la oferta', right: 'Dejarlo ir' },
    c009: { title: 'Engineering Manager',
            prompt: 'La mitad de mi equipo cree que la roadmap es trabajo de rendimiento. La otra mitad cree que es el rediseño.',
            left: 'Aclarar en un doc', right: 'Que pregunten al EM' },
    c010: { title: 'Product Designer',
            prompt: 'Marketing me empujó un Figma con su idea para la página de pricing. Usa Comic Sans.',
            left: 'Rehacerlo amablemente', right: 'Reenviar al equipo brand' },
    c011: { title: 'CEO',
            prompt: '"¿Por qué seguimos con OKRs trimestrales? Anthropic entrega cada seis semanas."',
            left: 'Probar ciclos de 6 semanas', right: 'Defender el trimestre' },
    c012: { title: 'Procurement',
            prompt: 'Necesitan un informe SOC 2 Tipo II antes de fin de mes o no renuevan.',
            left: 'Prometer la fecha', right: 'Empujar al próximo trimestre' },
    c013: { title: 'Account Executive',
            prompt: 'El prospect en la demo preguntó si tenemos integración con HubSpot. No la tenemos. ¿Puedo decirle "en la roadmap"?',
            left: 'Sí, promételo suave', right: 'No, dile que no' },
    c014: { title: 'Senior Data Scientist',
            prompt: 'Creo que el funnel de activación está doble-contando los trials del mismo dominio.',
            left: 'Pausar la métrica', right: 'Arreglar discreto luego' },
    c015: { title: 'Becario de Producto',
            prompt: '"¿Puedo asistir al offsite de leadership? Solo tomaría notas."',
            left: 'Llevarlo', right: 'Quizá la próxima' },
    c016: { title: 'Ingeniero Senior',
            prompt: 'Hay seis meses de deuda de diseño en la página de settings. ¿Quieres que lo arregle en mi 20%?',
            left: 'Sí por favor', right: 'Quédate con la roadmap' },
    c017: { title: 'UX Researcher',
            prompt: 'Tengo cinco entrevistas con usuarios. ¿Quieres unirte a una para ver?',
            left: 'Bloquear 2h, ir', right: 'Solo manda las notas' },
    c018: { title: 'CRO',
            prompt: 'Sales dice que cerraríamos un 30% más con un tier gratis. Marketing dice que mataría la conversión.',
            left: 'Lanzar piloto tier gratis', right: 'Mantener la línea' },
    c019: { title: 'Power User, ScaleCo',
            prompt: '"Vuestro export CSV trunca a 10k filas y necesitamos 100k. Esto bloquea nuestro trimestre."',
            left: 'Subir el límite', right: 'Sugerir la API' },
    c020: { title: 'AE Enterprise',
            prompt: 'Su CTO quiere una llamada de 30 min con "el PM que de verdad lleva la roadmap". Eres tú.',
            left: 'Aceptar la llamada', right: 'Mandar un deck' },
    c021: { title: 'Frontend Lead',
            prompt: '¿Migramos el design system a v3 antes o después del lanzamiento del rediseño?',
            left: 'Antes (hacerlo bien)', right: 'Después (entregar primero)' },
    c022: { title: 'Data Scientist',
            prompt: 'Mixpanel dice que la retención sube un 4%. Amplitude dice que es plano. Ambos los cablearon becarios.',
            left: 'Auditar ambos', right: 'Citar Mixpanel igual' },
    c023: { title: 'VP Producto',
            prompt: '¿Puedes escribir un one-pager sobre "product-led growth" para el viernes? Solo tres slides.',
            left: 'Hacerlo de verdad', right: 'Reciclar el post de Lenny' },
    c024: { title: 'Becario de Producto',
            prompt: 'He notado que el email de activación sale 14 minutos después del registro. ¿Debería ser instantáneo?',
            left: 'Arreglarlo hoy', right: 'Abrir un ticket' },
    c025: { title: 'Reclutadora Tech',
            prompt: 'Tenemos headcount para un PM más. ¿Senior generalista o junior con perfil growth?',
            left: 'Senior generalista', right: 'Junior orientado growth' },
    c026: { title: 'Diseñadora Senior',
            prompt: '¿A/B testeamos la nueva página de pricing o la entregamos directa?',
            left: 'A/B testearla', right: 'Entregarla directa' },
    c027: { title: 'Ingeniera Staff',
            prompt: 'Tenemos un bug P1 en producción. La ingeniera de guardia está en la boda de su hermana.',
            left: 'Avisar a otro', right: 'Esperar a mañana' },
    c028: { title: 'Equipo de Seguridad',
            prompt: '"Tu story de residencia de datos no está clara. Necesitamos EU-only para el Q3 o no podemos expandirnos."',
            left: 'Comprometerse al Q3', right: 'Empujarlo al Q4' },
    c029: { title: 'Account Executive',
            prompt: 'Le dije a un prospect que íbamos a construir un sync de Salesforce. Tranqui, es pequeño.',
            left: 'Añadirlo a la roadmap', right: 'Hacerle retractarse' },
    c030: { title: 'Senior Data Scientist',
            prompt: 'La métrica North Star es "weekly active teams". La mitad de la empresa rastrea "daily active users".',
            left: 'Forzar alineación', right: 'Dejarlos derivar' },
    c031: { title: 'CFO',
            prompt: 'La factura cloud subió un 38% el mes pasado. ¿Eras tú?',
            left: 'Investigar', right: 'Culpar al vendor' },
    c032: { title: 'Product Designer',
            prompt: 'Quiero hacer un design sprint en offsite. Tres días, sin reuniones. ¿Aprobado?',
            left: 'Aprobado', right: 'Quizá el próximo trimestre' },
    c033: { title: 'Engineering Manager',
            prompt: 'Mi equipo quiere reescribir el servicio de billing en Rust. Ya están prototipando.',
            left: 'Parar el proto', right: 'Time-box una semana' },
    c034: { title: 'Power User, ScaleCo',
            prompt: '"Prometiste dark mode en el QBR. Han pasado seis meses."',
            left: 'Entregar dark mode ya', right: 'Disculparse, reprogramar' },
    c035: { title: 'AE Enterprise',
            prompt: '¿Puedo compartir la roadmap de Notion con el prospect? No paran de preguntar.',
            left: 'Mandar un PDF saneado', right: 'Mandar el link en vivo' },
    c036: { title: 'Data Scientist',
            prompt: 'Construí un modelo de churn. Dice que nuestro mayor cliente se va en 47 días.',
            left: 'Avisar a su CSM', right: 'Esperar más señal' },
    c037: { title: 'Becario de Producto',
            prompt: '"Mis prácticas acaban en dos semanas. ¿Alguna posibilidad de oferta de retorno?"',
            left: 'Sí, lucharé por ti', right: 'Honesto: no estoy seguro' },
    c038: { title: 'Reclutadora Tech',
            prompt: 'El candidato nos hizo ghost después del take-home. ¿Podemos saltárnoslo para los seniors?',
            left: 'Saltar para seniors', right: 'Mantener el listón' },
    c039: { title: 'CEO',
            prompt: 'Quiero una demo en el All Hands del viernes. Elige algo guay.',
            left: 'Demo de la feature IA a medias', right: 'Demo del fix billing aburrido' },
    c040: { title: 'Ingeniero Senior',
            prompt: 'Nuestro entorno staging no funciona desde hace tres semanas. Nadie es dueño.',
            left: 'Hacerse dueño', right: 'Es problema de SRE' },
    c041: { title: 'Diseñadora Senior',
            prompt: 'Brand quiere refrescar nuestro logo. Tienen un moodboard con siete serifas.',
            left: 'Dejar a brand decidir', right: 'Pedirles que esperen' },
    c042: { title: 'Admin',
            prompt: '"Vuestra última release rompió silenciosamente nuestro setup SAML. Estamos de vuelta a email/contraseña."',
            left: 'Rollback esta noche', right: 'Parchar por la mañana' },
    c043: { title: 'Account Executive',
            prompt: 'El CTO del prospect quiere ver nuestro Jira board real. "Por confianza".',
            left: 'Compartir vista saneada', right: 'No, eso es raro' },
    c044: { title: 'Senior Data Scientist',
            prompt: 'Looker Studio se cayó. Dos execs me están pingueando. ¿Puedo solo mandarles el CSV de ayer?',
            left: 'Mandar el CSV', right: 'Hacerlos esperar' },
    c045: { title: 'VP Producto',
            prompt: 'Te pongo a presentar en el offsite de leadership. 20 minutos, sin slides.',
            left: 'Tomar el slot', right: 'Declinar amablemente' },
    c046: { title: 'Frontend Lead',
            prompt: '¿Adoptamos React 19 ahora o esperamos seis meses a que se asiente?',
            left: 'Adoptar ahora', right: 'Esperar seis meses' },
    c047: { title: 'Becario de Producto',
            prompt: '"Hice shadow en tres calls de sales y un doc sobre las objeciones top. ¿Podemos entregar un fix?"',
            left: 'Llevarlo al standup', right: 'Guardar para el próximo trimestre' },
    c048: { title: 'Reclutadora Tech',
            prompt: 'El candidato dijo que quiere "trabajar en algo que importe". ¿Le mando el deck de valores?',
            left: 'Mandar el deck', right: 'Solo ser honesto' },
    c049: { title: 'Power User',
            prompt: '"Pagaría el doble si me dejarais self-host. No me fío de nadie con mis datos, sin ofender."',
            left: 'Explorar tier self-hosted', right: 'Declinar amablemente' },
    c050: { title: 'CRO',
            prompt: '¿Podemos adelantar el aumento de rate-limit de la API dos semanas? Desbloquearía tres deals.',
            left: 'A ver qué puedo hacer', right: 'No, el equipo está al límite' },
    c051: { title: 'Product Designer',
            prompt: 'Diseñé tres opciones para la nueva nav. Una atrevida, una segura, una para ingenieros.',
            left: 'Entregar la atrevida', right: 'Entregar la segura' },
    c052: { title: 'Ingeniera Staff',
            prompt: 'La deuda técnica que marqué en la semana 1 ahora bloquea el lanzamiento. ¿Toca postmortem?',
            left: 'Sí, postmortem completo', right: 'No, seguimos' },
    c053: { title: 'Data Scientist',
            prompt: 'Nuestro gráfico DAU tiene un pico raro los domingos. Creo que es tráfico bot del docs site.',
            left: 'Quitarlo de la métrica', right: 'Dejarlo, queda bien' },
    c054: { title: 'CEO',
            prompt: 'Stripe acaba de entregar lo que llevamos tres trimestres construyendo. ¿Quieres que les llame?',
            left: 'Hablar con Patrick', right: 'No, tenemos un ángulo' },
    c055: { title: 'Admin',
            prompt: '"Llevamos 90 días en el trial. Necesitamos una extensión de 90 días."',
            left: 'Concedérselo', right: 'Hacerles comprometerse' },
    c056: { title: 'AE Enterprise',
            prompt: 'Procurement quiere un descuento por volumen del 60%. El CRO dice sí. El modelo dice no.',
            left: 'Mantener la línea', right: 'Aceptar el descuento' },
    c057: { title: 'Engineering Manager',
            prompt: 'Dos de mis mejores ingenieros quieren pasar al equipo plataforma. Perderíamos velocidad en la roadmap.',
            left: 'Dejarles ir', right: 'Bloquear el traslado' },
    c058: { title: 'UX Researcher',
            prompt: 'Ocho de diez usuarios se atascaron en la página de settings en el test de usabilidad. ¿Quieres los clips?',
            left: 'Mandar a leadership', right: 'Solo arreglarlo discreto' },
    c059: { title: 'Becario de Producto',
            prompt: '"He notado que el link de unsubscribe está roto. Voy a arreglarlo antes de irme."',
            left: 'Aprobar el fix', right: 'Que lo haga un FTE' },
    c060: { title: 'VP Producto',
            prompt: 'Necesito un 30-60-90 tuyo para el consejo. Mañana.',
            left: 'Echar una nochevieja', right: 'Mandar el del trimestre pasado' },
    c061: { title: 'Ingeniero Senior',
            prompt: '¿Hago mi propio deck de retro o uso la plantilla del equipo?',
            left: 'Usar la plantilla', right: 'Hacer el tuyo' },
    c062: { title: 'Diseñadora Senior',
            prompt: 'Llamamos a nuestro design system "Atlas" pero legal dice que la marca es de otro.',
            left: 'Renombrarlo', right: 'Arriesgarse' },
    c063: { title: 'Senior Data Scientist',
            prompt: 'Marketing me pidió hacer un A/B test sobre una feature ya 100% desplegada.',
            left: 'Decirles que no', right: 'Falsearlo con un holdout' },
    c064: { title: 'Power User, ScaleCo',
            prompt: '"Vuestro competidor ofreció migrarnos gratis. Convénceme de quedarme."',
            left: 'Tener una llamada', right: 'Mandar el deck' },
    c065: { title: 'Account Executive',
            prompt: '¿Puedes asistir al QBR? El cliente pidió específicamente "alguien técnico".',
            left: 'Sí', right: 'Manda al EM' },
    c066: { title: 'CFO',
            prompt: 'El burn de tu equipo está un 12% sobre el plan. ¿Qué se corta?',
            left: 'Cortar los experimentos IA', right: 'Cortar el rediseño' },
    c067: { title: 'Frontend Lead',
            prompt: 'Tenemos oportunidad de deprecar el soporte IE11. Nos ahorra 200ms en cada página.',
            left: 'Deprecarlo', right: 'Esperar un año más' },
    c068: { title: 'Becario de Producto',
            prompt: '"Último día. Hice un deck con todo lo que creo que deberías arreglar. ¿Quieres verlo?"',
            left: 'Leerlo con cuidado', right: 'Hojearlo luego' },
    c069: { title: 'Reclutadora Tech',
            prompt: 'Tres personas del equipo ingeniería quieren referir amigos. ¿Bajamos el listón?',
            left: 'Mantener el listón', right: 'Fast-track referrals' },
    c070: { title: 'CRO',
            prompt: 'Sales quiere "IA" en la copy de producto en cada página. ¿Podemos entregar un banner esta semana?',
            left: 'Sí, ponérselo', right: 'No, eso es ruido' },
    c071: { title: 'Ingeniera Staff',
            prompt: 'Estoy pensando en irme. No por dinero. La roadmap no me emociona.',
            left: 'Tener un 1:1 real', right: 'Desearle suerte' },
    c072: { title: 'Product Designer',
            prompt: 'Marketing quiere usar los screens v2 sin lanzar en un vídeo de lanzamiento. Pre-lanzamiento.',
            left: 'No, no está hecho', right: 'Claro, por qué no' },
    c073: { title: 'Data Scientist',
            prompt: 'Reconstruí el funnel. La activación real es 11%, no 24%. Llevamos diciendo 24% a inversores.',
            left: 'Decirlo esta noche', right: 'Sentarse encima' },
    c074: { title: 'Procurement',
            prompt: '"Toca renovación. Queremos un 30% de reducción o nos vamos al vendor X."',
            left: 'Igualar el descuento', right: 'Dejarlos ir' },
    c075: { title: 'AE Enterprise',
            prompt: '¿Puedes venir a mi cena con prospect el viernes? Pidieron específicamente "perspectiva de producto".',
            left: 'Ir a la cena', right: 'Mandar un deck' },
    c076: { title: 'Engineering Manager',
            prompt: 'Mi equipo hizo una retro blameless. La mitad de los items son sobre tus cambios de roadmap.',
            left: 'Leerlo, asumirlo', right: 'Empujar contra el framing' },
    c077: { title: 'CEO',
            prompt: 'Quiero que pilotes una nueva motion GTM. Self-serve. Tú decides el equipo.',
            left: 'Aceptarlo', right: 'Mantener el foco' },
    c078: { title: 'Becario de retorno',
            prompt: '"Vuelvo de la escuela. Tengo oferta de retorno de Meta. ¿Me quedo allí o vengo aquí?"',
            left: 'Convencerlo', right: 'Pros y contras honestos' },
    c079: { title: 'Reclutadora Tech',
            prompt: 'Tenemos un PM senior perfecto. Quiere full remote. Somos "híbrido flexible".',
            left: 'Hacer una excepción', right: 'Mantener la política' },
    c080: { title: 'UX Researcher',
            prompt: 'Tenemos presupuesto para una iniciativa grande de research. ¿Deep-dive de onboarding o entrevistas de churn?',
            left: 'Onboarding', right: 'Entrevistas de churn' },
    c081: { title: 'Ingeniero Senior',
            prompt: 'Me gustaría escribir un post de ingeniería público sobre nuestra migración. Marketing dijo no.',
            left: 'Anular a marketing', right: 'Apoyar a marketing' },
    c082: { title: 'Power User',
            prompt: '"Tenéis un alpha privado para la feature IA. ¿Puedo entrar? Os doy un testimonial."',
            left: 'Añadirlos', right: 'Esperar la GA' },
    c083: { title: 'VP Producto',
            prompt: 'Me voy en un mes. ¿Quieres mi puesto? Te respaldaría, pero llevas 80 días aquí.',
            left: 'Sí', right: 'Aún no' },
    c084: { title: 'Senior Data Scientist',
            prompt: 'Quiero montar una review semanal de métricas de producto. 30 min, cada lunes. ¿Aprobado?',
            left: 'Aprobado', right: 'Tenemos demasiadas reuniones' },
    c085: { title: 'Account Executive',
            prompt: '¿Puedo grabar tu demo y mandárselo a leads? Sacamos 3x más respuesta cuando los PMs lo hacen.',
            left: 'Vale, grábalo', right: 'No soy Marketing' },
    c086: { title: 'Frontend Lead',
            prompt: 'Tenemos que deprecar la API antigua. Dos clientes están en ella. Ambos diminutos. Ambos van a gritar.',
            left: 'Deprecar según lo previsto', right: 'Retrasar seis meses' },
    c087: { title: 'Diseñadora Senior',
            prompt: 'Quiero dejar de diseñar en Figma y probar Penpot. El equipo está dividido.',
            left: 'OK, pruébalo', right: 'Quédate con Figma' },
    c088: { title: 'CRO',
            prompt: 'Quiero una roadmap pública. Sales lo adoraría. Ingeniería lo odiaría.',
            left: 'Entregar roadmap pública', right: 'Mantenerla interna' },
    c089: { title: 'CISO',
            prompt: '"Tuvisteis un incidente menor el mes pasado. Queremos un postmortem por escrito y un crédito."',
            left: 'Mandar ambos', right: 'Solo el postmortem' },
    c090: { title: 'Becario de retorno',
            prompt: '"Para mi presentación final: ¿lo único que te hubiera gustado que te dijeran el día uno?"',
            left: 'Ser honesto', right: 'Decir algo seguro' },
    c091: { title: 'Frontend Lead',
            prompt: 'Ingeniería quiere migrar de Jira a Linear. La mitad del equipo tiene memoria muscular en queries de Jira.',
            left: 'Aprobar el cambio', right: 'Quedarse en Jira' },
    c092: { title: 'Product Designer',
            prompt: 'Ingeniería quiere Storybook para cada componente. Tres semanas de trabajo, sin cambio visible al usuario.',
            left: 'Hacer el tiempo', right: 'Saltarse por ahora' },
    c093: { title: 'VP Producto',
            prompt: 'Mi deck para el consejo tiene 47 slides. ¿Me ayudas a recortarlo antes del jueves?',
            left: 'Recortarlo a 12', right: 'Añadir un anexo' },
    c094: { title: 'Power User',
            prompt: '"¿Por qué vuestro soporte está en Intercom y no en Slack? Vivimos en Slack."',
            left: 'Añadir un canal Slack', right: 'Quedarse con Intercom' },
    c095: { title: 'AE Enterprise',
            prompt: 'Procurement quiere indemnización ilimitada en el contrato. Legal dijo nunca. Sales dice sí.',
            left: 'Cap a 1M$', right: 'Aceptar ilimitado' },
    c096: { title: 'Senior Data Scientist',
            prompt: 'Tenemos 47 dashboards. Ocho personas los usan. ¿Quieres que deprecemos los 30 de abajo?',
            left: 'Deprecarlos', right: 'Dejarlos en paz' },
    c097: { title: 'Engineering Manager',
            prompt: 'Necesitamos rotación on-call 24/7. Tres ingenieros se niegan. Dos dicen que dimitirán si se les obliga.',
            left: 'Hacerlo voluntario', right: 'Imponerlo' },
    c098: { title: 'Diseñadora Senior',
            prompt: 'Brand quiere un doc de 60 páginas de guidelines. Ingeniería dice que nadie lo leerá.',
            left: 'Construir el doc completo', right: 'Un one-pager basta' },
    c099: { title: 'Becario de retorno',
            prompt: '"Quiero un mentor fuera de mi cadena. ¿Puedes encontrarme uno?"',
            left: 'Conectarlos', right: 'Sugerir que se busque la vida' },
    c100: { title: 'CRO',
            prompt: '¿Comprar el módulo de analytics de CompetitorCo por 400k$ o construirlo nosotros en dos trimestres?',
            left: 'Comprarlo', right: 'Construirlo nosotros' },
    c101: { title: 'Admin',
            prompt: 'NPS bajó 14 puntos en un mes. Los verbatims mencionan todos "rendimiento".',
            left: 'Pausar features por perf', right: 'Empujar perf al próximo trimestre' },
    c102: { title: 'Reclutadora Tech',
            prompt: 'Hicimos benchmark de nuestra banda de comp PM. Estamos un 18% por debajo del mercado. RR.HH. se niega a ajustar.',
            left: 'Escalar al CEO', right: 'Vivir con ello' },
    c103: { title: 'Ingeniero Senior',
            prompt: 'Quiero dividir el monorepo. Son ocho meses de trabajo. El equipo está dividido.',
            left: 'Aprobar la división', right: 'Mantener el monorepo' },
    c104: { title: 'Account Executive',
            prompt: 'Un revendedor quiere etiquetarnos blanco en APAC. 30% de margen para ellos, cero coste GTM para nosotros.',
            left: 'Firmar el deal', right: 'Quedarse directo' },
    c105: { title: 'CEO',
            prompt: 'Quiero contratar un Head of AI. El candidato viene de OpenAI y quiere 700k$ base.',
            left: 'Hacer la oferta', right: 'Promocionar internamente' },
    c106: { title: 'Data Scientist',
            prompt: 'Auditoría RGPD encontró cuatro cookies que ponemos sin consentimiento. Legal los quiere fuera esta noche.',
            left: 'Quitarlos esta noche', right: 'Programar para el sprint' },
    c107: { title: 'UX Researcher',
            prompt: 'Auditoría de accesibilidad encontró 38 fallos WCAG-AA. La mayoría son contraste de color.',
            left: 'Bloquear release', right: 'Entregar, abrir tickets' },
    c108: { title: 'Power User, ScaleCo',
            prompt: '"Vuestra status page decía \'todos los sistemas operacionales\' durante una caída de 90 minutos. Lo notamos."',
            left: 'Postmortem + disculpas', right: 'Actualizar el SLA discreto' },
    c109: { title: 'AE Enterprise',
            prompt: 'Tengo tres RFPs para el viernes. Cada uno son 80 páginas de preguntas de compliance.',
            left: 'Ayudar con los tres', right: 'Triar a uno' },
    c110: { title: 'CFO',
            prompt: 'Estamos a 18 meses de default. ¿Despidos o cortar la próxima línea de producto?',
            left: 'Cortar la línea de producto', right: 'Despidos pequeños' },
    f_custom_arr: { title: 'AE Enterprise',
            prompt: 'Tres semanas después. La feature custom de 500k€ se entregó. Quieren dos más.',
            left: 'Mantener la línea', right: 'Construir la siguiente' },
    f_salesforce_sync: { title: 'Engineering Manager',
            prompt: 'Sobre el sync de Salesforce. Son tres sprints de trabajo. No tenemos tres sprints.',
            left: 'Cortar otra feature', right: 'Decirle a sales que no va a pasar' },
    f_indemnity: { title: 'AE Enterprise',
            prompt: 'Tres semanas después. El cliente activó una reclamación de 3M$ bajo esa indemnización ilimitada.',
            left: 'Pagar, aprender', right: 'Pelearlo en tribunales' },
    f_oncall: { title: 'Engineering Manager',
            prompt: 'Dos semanas después. La on-call voluntaria tuvo un voluntario. Está quemándose rápido.',
            left: 'Pagar extra, doblar rotación', right: 'Imponerlo ya' },
    f_brand: { title: 'Diseñadora Senior',
            prompt: 'El doc de brand de 60 páginas está hecho. Ingeniería no usa nada de él.',
            left: 'Imponer cumplimiento', right: 'Dejarlo morir discreto' },
    f_buy_build: { title: 'CRO',
            prompt: 'El módulo de CompetitorCo no se integra. Su API no está documentada.',
            left: 'Exigir reembolso', right: 'Construir un wrapper' },
    f_monorepo: { title: 'Ingeniero Senior',
            prompt: 'Tres meses después. La división está a medias. La CI está rota en ambos repos.',
            left: 'Hacer rollback', right: 'Empujar adelante' },
    f_channel: { title: 'Account Executive',
            prompt: 'El revendedor APAC está rompiendo precios en nuestros deals directos en ANZ. Los clientes están confundidos.',
            left: 'Sacar ANZ', right: 'Cortar al revendedor' },
    f_ai_hire: { title: 'CEO',
            prompt: 'El Head of AI empezó el lunes. Para el viernes quiere redirigir toda la roadmap.',
            left: 'Escucharlo', right: 'Mantener la línea' },
    f_a11y: { title: 'UX Researcher',
            prompt: 'Los 38 fixes WCAG se entregaron. Sales dice que ahora somos elegibles para un RFP de sector público.',
            left: 'Perseguir el RFP', right: 'Quedarse en SMB' },
    f_rfp: { title: 'AE Enterprise',
            prompt: 'Ganamos uno de los tres RFPs. La entrega comprometida es 6 semanas. Ingeniería se rió.',
            left: 'Renegociar el scope', right: 'Prometer, luego estirar' },
    f_layoffs: { title: 'CFO',
            prompt: 'La línea de producto que cortaste tenía tres clientes pagando 1.2M$ ARR. Quieren reembolsos.',
            left: 'Reembolsar al completo', right: 'Ofrecer crédito en el principal' },
    c111: { title: 'CTO',
            prompt: 'Quiero internalizar todo. Dejamos AWS, dejamos Stripe, lo construimos nosotros. Plan a tres años.',
            left: 'Hacer estudio de viabilidad', right: 'Quedarse con lo que tenemos' },
    c112: { title: 'Mobile Lead',
            prompt: 'Apple acaba de rechazar nuestra app. Marcaron la feature IA como "generación de información no verificada".',
            left: 'Reenviar con disclaimers', right: 'Pelear el rechazo' },
    c113: { title: 'VP Producto',
            prompt: 'Quiero que la planificación trimestral dure cinco días, no dos. OKRs reales, no slides.',
            left: 'Adoptarlo', right: 'Dos días bastan' },
    c114: { title: 'Power User',
            prompt: '"Queremos ser design partner. Producto gratis, vosotros os lleváis nuestro logo y una cita."',
            left: 'Inscribirlos', right: 'No necesitamos su logo' },
    c115: { title: 'Ingeniero de Seguridad',
            prompt: 'El pen test encontró tres vulns RCE en la API. Tenemos 24 horas antes de la divulgación.',
            left: 'Todos a parchear esta noche', right: 'Negociar la ventana de divulgación' },
    c116: { title: 'Sales Engineer',
            prompt: 'El RFP del prospect requiere conformidad GDPR + CCPA + LGPD + PIPEDA. Tenemos GDPR.',
            left: 'Comprometerse a las cuatro', right: 'Descalificarnos' },
    c117: { title: 'Senior Data Scientist',
            prompt: 'Marketing quiere trackear cada evento de página en Mixpanel. El script de tracking pesa 240KB.',
            left: 'Recortar a eventos clave', right: 'Trackear todo, ordenar luego' },
    c118: { title: 'Product Designer',
            prompt: 'Brand quiere un refresh completo. Logo, paleta, tipografía. Seis meses de trabajo.',
            left: 'Liderar el proyecto', right: 'Empujar atrás, foco en producto' },
    c119: { title: 'CEO',
            prompt: 'Quiero adquirir ToolCo. 2k clientes, 4M$ ARR, sin crecimiento. Deal de 20M$.',
            left: 'Hacer due diligence', right: 'Pasar' },
    c120: { title: 'Reclutadora Tech',
            prompt: 'Tres de nuestros PMs fueron reclutados por LinkedIn esta semana. Tres competidores distintos.',
            left: 'Investigar la cultura', right: 'Esperar a que pase' },
    c121: { title: 'CRO',
            prompt: 'Quiero a cada PM en llamadas de sales semanalmente. Obligatorio.',
            left: 'Probarlo', right: 'Bi-semanal, opt-in' },
    c122: { title: 'Ingeniero Senior',
            prompt: 'Nuestro sitio docs tiene 60% de bounce. ¿Quieres que dedique un sprint a reescribirlo?',
            left: 'Aprobar el sprint', right: 'Contratar un tech writer' },
    c123: { title: 'Procurement',
            prompt: '"Queremos nuestro logo FUERA de vuestra homepage. Razones de compliance."',
            left: 'Quitar esta noche', right: 'Empujar atrás, activo de sales' },
    c124: { title: 'Data Scientist',
            prompt: 'Quiero publicar un paper sobre nuestro modelo de churn. Co-autor con académicos.',
            left: 'Aprobar', right: 'Cabeza abajo' },
    c125: { title: 'Becario de retorno',
            prompt: '"Voy a publicar un post de Medium sobre mis prácticas. ¿Quieres revisarlo?"',
            left: 'Leer con cuidado', right: 'Confiar' },
    c126: { title: 'Chief of Staff',
            prompt: 'El CEO quiere que redactes su update al consejo. Lo revisará mañana.',
            left: 'Aceptarlo', right: 'Declinar amablemente' },
    c127: { title: 'UX Researcher',
            prompt: 'Quiero entrevistar a vuestros peores clientes. Los que se fueron enfadados.',
            left: 'Aprobar el presupuesto', right: 'Quedarse con users actuales' },
    c128: { title: 'Frontend Lead',
            prompt: 'Tenemos un bundle JS de 4MB. Sales dice que el producto se siente "lento".',
            left: 'Hacer un sprint de perf', right: 'Vivir con ello' },
    c129: { title: 'AE Enterprise',
            prompt: 'El cliente quiere un canal Slack privado compartido con el equipo de ingeniería.',
            left: 'Abrir el canal', right: 'Usar Intercom' },
    c130: { title: 'CFO',
            prompt: 'Nuestros costes cloud se disparan en Black Friday. ¿Reserved instances o autoscale?',
            left: 'Capacidad reservada', right: 'Autoscale, asumir el coste' },
    c131: { title: 'Ingeniera Staff',
            prompt: 'Reescribí el rate-limiter un sábado. La PR está abierta.',
            left: 'Revisar y mergear', right: 'No normalizar trabajo en finde' },
    c132: { title: 'Diseñadora Senior',
            prompt: 'Voy a dar la charla WWDC sobre accesibilidad. ¿Tiempo libre?',
            left: 'Aprobar, apoyo total', right: 'Mejor un evento más pequeño' },
    c133: { title: 'Head of Talent',
            prompt: 'Tenemos una oferta PM senior fuera. Quiere renegociar el cliff de vesting.',
            left: 'Renegociar', right: 'Mantener la línea' },
    c134: { title: 'Engineering Manager',
            prompt: 'Quiero pasar de reviews de performance trimestrales a mensuales. La calibración se complica.',
            left: 'Probarlo', right: 'Quedarse trimestral' },
    c135: { title: 'Legal',
            prompt: 'Un ingeniero basado en Rusia tocó nuestros datos a través de nuestro subprocesador.',
            left: 'Investigar inmediatamente', right: 'Cortar el subprocesador' },
    c136: { title: 'CTO en TenantCo',
            prompt: '"Queremos un despliegue private cloud. Air-gapped. Pagamos 5x."',
            left: 'Construir la oferta', right: 'Pasar, no es nuestro modelo' },
    c137: { title: 'Account Executive',
            prompt: 'Hice un deck diciendo que somos "AI-first". No lo somos. Sales lo está usando.',
            left: 'Corregirlo ahora', right: 'Dejarlo correr' },
    c138: { title: 'Product Designer',
            prompt: 'Ingeniería borró mi config de design tokens en un refactor. Tres semanas perdidas.',
            left: 'Postmortem completo', right: 'Seguir, restaurar de git' },
    c139: { title: 'CEO',
            prompt: 'Le dije a Bloomberg que entregaríamos la feature IA para fin de año. Es octubre.',
            left: 'Mover cielo y tierra', right: 'Echar atrás' },
    c140: { title: 'VP Producto',
            prompt: 'Me voy de sabático. ¿Quieres ser VP en funciones tres meses?',
            left: 'Sí', right: 'No' },
    f_in_house: { title: 'CTO',
            prompt: 'Seis meses después. Vamos atrasados con el build interno. La factura AWS no ha bajado.',
            left: 'Tirar la toalla', right: 'Empujar adelante' },
    f_apple_reject: { title: 'Mobile Lead',
            prompt: 'Apple aceptó el reenvío. Google rechazó el mismo día.',
            left: 'Negociar con Google', right: 'Entregar Apple-only' },
    f_design_partner: { title: 'Power User',
            prompt: '"El design partner ahora exige un asiento en la roadmap."',
            left: 'Darle el asiento', right: 'Declinar amablemente' },
    f_pen_test: { title: 'Ingeniero de Seguridad',
            prompt: 'Parcheamos los RCE. El investigador publicó igualmente.',
            left: 'Coordinar la divulgación', right: 'Demandar por incumplimiento' },
    f_brand_refresh: { title: 'Product Designer',
            prompt: 'El refresh de brand se entregó. Twitter se rió del nuevo logo.',
            left: 'Defenderlo públicamente', right: 'Iterar a v1.5' },
    f_acquisition: { title: 'CEO',
            prompt: 'El CEO de ToolCo quiere un asiento en el consejo como parte del deal. Los fundadores están divididos.',
            left: 'Dar el asiento', right: 'Romper el deal' },
    f_perf_sprint: { title: 'Frontend Lead',
            prompt: 'El bundle está en 1.2MB. Algunas features se rompieron.',
            left: 'Rollback de las rotas', right: 'Hotfix hacia adelante' },
    f_private_slack: { title: 'AE Enterprise',
            prompt: 'El Slack cliente-ingeniería ahora tiene a otros seis PMs leyendo.',
            left: 'Cerrarlo', right: 'Dejar que crezca' },
    f_data_breach: { title: 'Legal',
            prompt: 'Forense dice que los datos de un cliente fueron accedidos. Están preguntando ahora.',
            left: 'Divulgar esta noche', right: 'Esperar a legal' },
    f_acting_vp: { title: 'VP Producto',
            prompt: 'Karen se fue. El equipo está testando límites.',
            left: 'Poner el listón alto', right: 'Ganar confianza despacio' },
  },
};

export default locale;
